// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9kmJd","type":"styles_type__X6YG4","choices":"styles_choices__2xNdF"};